import { useSelectedViewTab } from "hooks/useSelectedViewTab";
import { columnNames } from "library/constants";
import { EBenefitTab, IBenefitCategory } from "library/types";
import { useEffect } from "react";
import { useInvalidateBenefitCategories } from "state/queries/useGetBenefitCategories";
import styled from "styled-components";
import { EditableTable } from "../EditableTable/EditableTable";
import { BenefitCardList } from "./BenefitCardList/BenefitCardList";
import { useIsFetching, useIsMutating } from "react-query";

type Props = {
  benefitCategories: IBenefitCategory[];
  benefitTableItems: any[];
  defaultColumnSizingOptions: any;
  columns: any[];
  columnNames: {
    [x: string]: string;
  };
  onRowClick?: (row) => void;
  countryCode: number;
  currencyCode?: number;
  clientInternalNumberGOS?: number;
  selectionMode?: "single" | "multiselect";
  hasImplementationActions?: boolean;
  searchFilterValue?: string;
};

export function ManageBenefitCategories({
  benefitCategories,
  benefitTableItems,
  defaultColumnSizingOptions,
  columns,
  selectionMode,
  countryCode,
  currencyCode,
  clientInternalNumberGOS = 0,
  onRowClick,
  hasImplementationActions,
  searchFilterValue = "",
}: Props) {
  const selectedTab = useSelectedViewTab();
  const invalidateBenefitCategories = useInvalidateBenefitCategories();

  useEffect(() => {
    invalidateBenefitCategories();
  }, [selectedTab]);

  return (
    <div>
      <TabContent>
        {selectedTab === EBenefitTab.list && (
          <EditableTable
            defaultColumnSizingOptions={defaultColumnSizingOptions}
            defaultItems={benefitTableItems}
            columns={columns}
            columnNames={columnNames}
            selectionMode={selectionMode}
            onRowClick={onRowClick}
            searchFilterValue={searchFilterValue}
          />
        )}
        {selectedTab === EBenefitTab.grid && (
          <BenefitCardList
            currencyCode={currencyCode}
            countryCode={countryCode}
            clientInternalNumberGOS={clientInternalNumberGOS}
            benefitCategories={benefitCategories}
            hasImplementationActions={hasImplementationActions}
          />
        )}
      </TabContent>
    </div>
  );
}

const TabContent = styled.div`
  margin-top: 20px;
`;
